module.exports = __webpack_public_path__ + "s.no2.75276343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/s.no2.jpg
// module id = xFqz
// module chunks = 0